export const getItems = state => state.advertisingBudget.items;

export default {
	getItems,
};
